export default __webpack_public_path__ + "static/media/49-min.257dcd2d.png";